module.exports = __webpack_public_path__ + "img/9-about.f178f5d5.jpg";